(function(){
    'use strict';

    $('.nav-toggle').on('click', function() {

        var panel = $(this).parents('.nav-item').find('.smp-navigation-dropdown__sub-outer');

        // Close
        if( $(this).hasClass('active') ) {

            panel.removeClass('active');
            panel.attr("aria-expanded","false");
            $(this).removeClass('active');

        // Open
        } else {

            panel.addClass('active');
            panel.attr("aria-expanded","true");
            $(this).addClass('active');
        }
    });

    // Allow for tabbing - accessibility
    $('.smp-navigation-dropdown .nav-item').each(function() {

        var panel = $(this).find('.smp-navigation-dropdown__sub-outer');

        $(this).keydown(function(e){

            // For when space bar is hit
            if( e.keyCode == 32 ) {
                // Open the dropdown
                if( !panel.hasClass('active')) {

                    panel.addClass('active');
                    panel.siblings().removeClass('active');
                    panel.attr("aria-expanded","true");

                    $(this).addClass('hover');
                    $(this).siblings().removeClass('hover');

                // Close the dropdown
                } else {

                    panel.removeClass('active');
                    panel.attr("aria-expanded","false");
                    $(this).removeClass('hover');
                }

                return false;

            // For when esc is hit
            } else if(e.keyCode == 27) {

                // Close the dropdown
                if( panel.hasClass('active') ) {

                    panel.removeClass('active');
                    panel.attr("aria-expanded","false");
                    $(this).removeClass('hover');
                }

                return false;
            }

        });

    });


    // Set up active classes
    // Data attribute lineage set by ESI args
    try {

        var $nav = $('.smp-navigation-dropdown [data-lineage]');

        // Contains an array of asset ids
        var lineage = $nav.data('lineage');

        if (lineage.length) {

            lineage.forEach(function(asset_id) {

                var $active_menu_item = $nav.find('[data-id=' + asset_id + ']');

                $active_menu_item.addClass("active");

            });

        }


    } catch (error) {

    }
    
}());

